import { GetStaticProps } from "next"
import BlogPageComponent from "pages/[blogname]"
import { handleBlogStaticProps, formatParamArray } from "util/ssr/blogPage"
import { wrapper } from "store"

export { getStaticPaths } from "pages/[blogname]"

export const getStaticProps: GetStaticProps = wrapper.getStaticProps(
  // @ts-ignore
  (store) => async (ctx) => {
    const { params } = ctx
    const paramArray = params?.path as string[]
    const formatted = formatParamArray("community", paramArray)

    return await handleBlogStaticProps({
      store,
      blogName: params?.blogname as string,
      pathParamArray: formatted,
    })
  }
)

export default function PathBlogComponent(props: any) {
  return <BlogPageComponent {...props} />
}

PathBlogComponent.getLayout = BlogPageComponent.getLayout
